import { useCallback, useState } from 'react';

import {
  BtnGroup,
  BtnToolbar,
  ButtonAction,
  type HookFormMethods,
  HookFormResolver,
  PageTitle
} from '@dec/shared';
import { Text } from '@dec/shared';
import { Button } from '@dec/shared';
import { type ColDef } from 'ag-grid-community';
import { t } from 'i18next';
import { Col, Row } from 'react-bootstrap';
import { CardChecklist } from 'react-bootstrap-icons';
import { useNavigate } from 'react-router-dom';

import GridApplication from '@/app/components/grid/gridApplication';
import { type CatalogTypeModel } from '../../models/Catalog';

import { baseUrlCatalogTypes } from '../../services/catalog.service';

import { getColumns } from './columns';

interface CatalogFilter {
  name?: string;
  description?: string;
}

interface CatalogListProps {
  handleEdit: (row: CatalogTypeModel) => void;
  handleCreate: () => void;
}

export const CatalogList = ({ handleEdit, handleCreate }: CatalogListProps) => {
  const navigate = useNavigate();

  const columns: Array<ColDef> = getColumns(handleEdit, (row: CatalogTypeModel) => {
    navigate(`/configuration/catalog/${row.id}/list`);
  });

  // columnas de la grilla
  const [search, setSearch] = useState<CatalogFilter>({});

  // ejecucióin de la busqueda con nuevos filtros
  // usecallback se usa para que no se cree una nueva función por cada render
  const handleSearch = useCallback((values: CatalogFilter) => {
    console.log({ values: values });
    // en este caso coinciden los valores de busqueda y los intresados por el form
    // caso contrario habria que transformarlos y definir interfaces particulares para c/uno
    setSearch(values);
  }, []);

  const handleClear = (reset: HookFormMethods['reset']) => {
    reset({});

    setSearch({});
  };

  return (
    <>
      <PageTitle title={t('catalog.list')} icon={CardChecklist} />

      <HookFormResolver onSubmit={handleSearch} initialValues={{ name: null }}>
        {({ reset }: HookFormMethods) => {
          return (
            <>
              <Row>
                <Col>
                  <Text label={t('common.label.name')} name="name" />
                </Col>
                <Col>
                  <Text label={t('parameters-catalog.label.description')} name="description" />
                </Col>
              </Row>

              <BtnToolbar>
                <BtnGroup>
                  <Button
                    action={ButtonAction.clean}
                    variant={'secondary'}
                    type={'reset'}
                    onClick={() => handleClear(reset)}
                  />
                </BtnGroup>
                <BtnGroup>
                  {/* el boton de nuevo abre un nuevo une nueva ventana de edición para agregar
                  un nuevo catálogo */}
                  <Button action={ButtonAction.new} onClick={handleCreate} />
                  <Button action={ButtonAction.find} type={'submit'} variant={'primary'} />
                </BtnGroup>
              </BtnToolbar>
            </>
          );
        }}
      </HookFormResolver>
      <Row className="mt-5">
        <Col>
          <GridApplication columnDefs={columns} url={baseUrlCatalogTypes} search={search} />
        </Col>
      </Row>
    </>
  );
};
